import { useIsCompanyProfilePage } from '@/components/misc/CompanyProfile/hooks/useIsCompanyProfilePage'

export function useIsCompanyProfileModal() {
  const isCompanyProfilePage = useIsCompanyProfilePage()

  // If we're not on the company profile page, it's safe to assume this is
  // the company profile modal
  return !isCompanyProfilePage
}
